import { Navigate, Route, Routes } from "react-router";
import InviteShell from "./pages/invite/InviteShell";
import {
  AccountSelectOutlet,
  AuthProvider,
  ErrorBoundary,
  PublicOutlet,
  VisualProvider,
} from "./components";
import NotFoundPage from "./pages/NotFoundPage";
import LoginPage from "./pages/login/LoginPage";
import PasswordShell from "./pages/password/PasswordShell";
import InviteOutlet from "./pages/invite/InviteOutlet";
import HomePage from "./pages/home/HomePage";
import OrdersShell from "./pages/orders/OrdersShell";
import ContactPage from "./pages/contact/ContactPage";
import DocumentPage from "./pages/documents/DocumentPage";
import InterventionsPage from "./pages/interventions/InterventionsPage";
import ServiceObjectsShell from "./pages/serviceObjects/ServiceObjectsShell";
import RequestsShell from "./pages/requests/RequestsShell";
import CustomerInfoPage from "./pages/customer/CustomerInfoPage";
import SettingsPage from "./pages/settings/SettingsPage";
import TestErrorComponent from "./components/errorBoundary/TestErrorComponent";
import AuthOutlet from "./components/outlets/AuthOutlet";
import AccountSelectPage from "./pages/account/AccountSelectPage";
import AdminLoginOutlet from "./components/outlets/AdminLoginOutlet";

const App: React.FC = (): React.ReactElement => {
  return (
    <AuthProvider>
      <Routes>
        <Route
          element={
            <ErrorBoundary>
              <VisualProvider />
            </ErrorBoundary>
          }
        >
          <Route element={<AccountSelectOutlet />}>
            <Route path="/account-select" element={<AccountSelectPage />} />
          </Route>
          <Route path="/admin-login" element={<AdminLoginOutlet />} />
          <Route path=":tenantCode/:customerId/*" element={<AuthOutlet />}>
            <Route index path="" element={<HomePage />} />
            <Route path="orders/*" element={<OrdersShell />} />
            <Route path="interventions" element={<InterventionsPage />} />
            <Route path="serviceObjects/*" element={<ServiceObjectsShell />} />
            <Route path="documents/:documentId" element={<DocumentPage />} />
            <Route path="requests/*" element={<RequestsShell />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="customer" element={<CustomerInfoPage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="*" element={<Navigate replace to="/404" />} />
          </Route>
          <Route element={<PublicOutlet />}>
            <Route path=":tenantCode/*">
              <Route element={<InviteOutlet />}>
                <Route
                  path="invite/:invitationGuid/*"
                  element={<InviteShell />}
                />
              </Route>
              <Route path="password/*" element={<PasswordShell />} />
              <Route index element={<LoginPage />} />
            </Route>
            <Route index element={<LoginPage />} />
            <Route path="password/*" element={<PasswordShell />} />
            <Route path="/404" element={<NotFoundPage />} />
          </Route>
          <Route path="*" element={<Navigate replace to="/404" />} />
          {/* TODO: remove before release */}
          <Route path="/test-error" element={<TestErrorComponent />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
};

export default App;
